import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-ess-paper">
      <Navbar />
      <main className="flex-1 pt-20" data-testid="ess-main">
        {children}
      </main>
      <Footer />
      <Toaster richColors position="top-right" />
    </div>
  );
};

export default Layout;
